(function() {
    'use strict'

    var pluginName = "reelVideo";
    var defaults = {
        /* some default options */
    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        init() {
            this.$element = $(this.element);
            this.$body = $('body');
            this.$logo = $('.js-reel-logo svg');
            this.$overlay = $('.js-reel-overlay');
            this.$fixedPlayer = $('.js-fixed-player');
            this.$ctaButton = $('.js-cta');
            this.$playButton = $('.js-play-video');
            this.player = $('.js-reel-video').get(0);

            this.bindEvents();
        },

        playVideo() {
            this.player.play();
            this.$playButton.removeClass('is-active');
        },

        pauseVideo() {
            this.player.pause();
        },

        scrollEvent(e, data) {
            let scrolled = data.scrolled * 1.75;
            scrolled = (scrolled > 1) ? 1 : scrolled;

            this.$overlay.css({
                opacity: scrolled
            });
        },

        handleCtaClick(e) {
          e.preventDefault();
          this.$body.attr('data-reel', 'movein');
          this.pauseVideo();
        },

        showReel(e) {
          if (e.type.toLowerCase() === 'click') {
            e.preventDefault();
            this.pauseVideo();
          }
          this.$fixedPlayer.removeClass('is-hidden');
          this.$fixedPlayer.trigger('play');
          window.setTimeout(() => {this.$body.attr('data-reel', true)}, 200);
        },

        // EVENTS
        bindEvents() {
          this.$element.on('setPlayerVolume', this.scrollEvent.bind(this));
          this.$element.on('playVideo', this.playVideo.bind(this));
          this.$ctaButton.on('click', this.showReel.bind(this));
          this.$playButton.on('click', this.playVideo.bind(this));
          $(window).on('load', () => {
            this.$ctaButton.off('click');
            this.$ctaButton.on('click', this.handleCtaClick.bind(this));
            this.$logo.on('transitionend', this.showReel.bind(this));
          });
          let startPlayPromise = this.player.play();
          if (startPlayPromise !== undefined) {
            startPlayPromise.then(() => {}).catch(error => {
              if (error.name === "NotAllowedError") {
                this.$playButton.addClass('is-active');
              }
            });
          }
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());
